import React from "react";

function Information() {
  return (
    <div className="container section center-block landing-page-text">
      <div
        className="half system-description"
        style={{ padding: "0", margins: "0" }}
      >
        <h2 style={{ marginTop: "0px" }}>
          <span className="ca-gov-icon-gears" /> What is HWTS?
        </h2>
        <div style={{ width: "85%" }}>
          <p>
            The Hazardous Waste Tracking System (HWTS) is the California
            Department of Toxic Substances Control’s (DTSC) data repository for
            hazardous waste manifest and ID Number information. DTSC relies on
            HWTS for issuing and tracking ID numbers, registering transporters,
            and providing information to analyze hazardous waste activities for
            policy purposes and enforcement. The system generates reports from
            1993 to the present on hazardous waste shipments for generators,
            transporters, and treatment, storage and disposal facilities
            (TSDFs). These reports are available to the public and subject to
            the limitations contained in the{" "}
            <a
              href="/documents/Internal_CUPA_Disclaimer.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Disclaimer and Data Limitations Statement
            </a>
            .
          </p>
        </div>
        <div
          className="full"
          style={{ margins: "0", marginTop: "20px", padding: "0" }}
        >
          <h3 style={{ marginBottom: "5px", marginTop: "5px" }}>
            <a
              href="https://dtsc.ca.gov/hwts-news/"
              target="_blank"
              rel="noopener noreferrer"
            >
              HWTS News
            </a>
          </h3>
          <div className="location contact" style={{ marginBottom: "0px" }}>
            <div className="contact" style={{ width: "100%" }} />
          </div>
          <div className="address">
            Learn about the latest HWTS news and information.
          </div>
        </div>
      </div>

      <div
        className="half related-links"
        style={{ padding: "0", margins: "0" }}
      >
        <h2 style={{ marginTop: "0px" }}>
          <span className="ca-gov-icon-link" /> Related Links
        </h2>
        <div className="full">
          <h3 style={{ marginBottom: "0px" }}>
            <a
              href="https://www.epa.gov/e-manifest"
              target="_blank"
              rel="noopener noreferrer"
            >
              U.S. EPA’s Electronic Manifest (e-Manifest) System
            </a>
          </h3>
          <div className="location contact" style={{ marginBottom: "0px" }}>
            <div className="contact" style={{ width: "100%" }}>
              <div className="address">
                The e-Manifest System was established by the United States
                Environmental Protection Agency (U.S. EPA) and is the national
                system for tracking hazardous waste shipments electronically.
                The system was launched on June 30, 2018 and will modernize the
                nation’s cradle-to-grave hazardous waste tracking process while
                saving time, resources, and dollars for industry and states.
                Visit the U.S. EPA’s e-Manifest webpage for information on user
                registration, webinars, stakeholder fact sheets, FAQs and more.
              </div>
            </div>
          </div>
        </div>

        <div
          className="full"
          style={{ margins: "0", marginTop: "20px", padding: "0" }}
        >
          <h3 style={{ marginBottom: "5px", marginTop: "5px" }}>
            <a
              href="http://www.dtsc.ca.gov/IDManifest/Manifests.cfm"
              target="_blank"
              rel="noopener noreferrer"
            >
              DTSC Manifest Information
            </a>
          </h3>
          <div className="location contact" style={{ marginBottom: "0px" }}>
            <div className="contact" style={{ width: "100%" }} />
          </div>
          <div className="address">
            Learn more about manifest regulations, where manifests are
            submitted, types of manifest reports, and manifest correction
            letters.
          </div>
        </div>
        <div
          className="full"
          style={{ margins: "0", marginTop: "20px", padding: "0" }}
        >
          <h3 style={{ marginBottom: "5px", marginTop: "5px" }}>
            <a
              href="https://evq.dtsc.ca.gov/Home.aspx"
              target="_blank"
              rel="noopener noreferrer"
            >
              DTSC’s Electronic Verification Questionnaire (eVQ) System
            </a>
          </h3>
          <div className="location contact" style={{ marginBottom: "0px" }}>
            <div className="contact" style={{ width: "100%" }} />
          </div>
          <div className="address">
            The eVQ System provides a fast and convenient way for required
            hazardous waste handlers to file their annual ID Number Verification
            Questionnaire and Manifest Fees Assessment with DTSC.
          </div>
        </div>
      </div>
    </div>
  );
}

export default Information;
